module.exports = __webpack_public_path__ + "img/footer_icon_line.44ac29c1.svg";